type PartnerType = {
  [key: string]: {
    title: string;
    logo: string;
    url: string;
  };
};

export const PARTNERS: PartnerType = {
  hu: {
    title: "HU (Hogeschool Utrecht)",
    logo: "https://uilogos.co/img/logomark/treva.png",
    url: "https://www.hu.nl",
  },
  hku: {
    title: "HKU (Hogeschool voor de Kunsten Utrecht)",
    logo: "https://uilogos.co/img/logomark/u-mark.png",
    url: "https://www.hku.nl",
  },
  han: {
    title: "HAN (Hogeschool Arnhem & Nijmegen)",
    logo: "https://uilogos.co/img/logomark/leaf.png",
    url: "https://www.hku.nl",
  },
};
